/* @ngInject */
const myLimitHandleButtons = (
  $$setting
) => {
  return {
    restrict: 'E',
    scope: {
      myLength: '=',
      myWagonsLength: '=',
    },
    template: require('./myLimitHandleButtons.html'),

    /* @ngInject */
    controller: (
      $scope,
      utils
    ) => {
      $scope.utils = utils
      $scope.utils.limit.step = $$setting.data.general.sliders.displayedItemNumber.model
      $scope.utils.limit.current = $$setting.data.general.sliders.displayedItemNumber.model
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myLimitHandleButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/buttons/myLimitHandleButtons.js